import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { checkboxDriverFactory } from '../Checkbox/Checkbox.driver';
import { CHECKBOX_DATA_HOOKS } from '../Checkbox/dataHooks';

export interface CheckboxGroupDriver extends BaseUniDriver {
  isCheckboxesExist(): Promise<boolean>;
  isCheckboxesDisabled(): Promise<boolean>;
  isCheckboxesErrored(): Promise<boolean>;
  getLang(): Promise<string>;
  clickAt(index: number): Promise<void>;
}

export const checkboxGroupDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): CheckboxGroupDriver => {
  const checkboxDriver = checkboxDriverFactory(base, body);
  const checkboxDatahook = `[data-hook="${CHECKBOX_DATA_HOOKS.CheckboxWrapper}"]`;

  return {
    ...baseUniDriverFactory(base),
    async clickAt(index: number) {
      const list = await base.getAll(checkboxDatahook);
      const checkboxes = await list.map(async (checkbox) =>
        checkboxDriverFactory(checkbox, body),
      );

      (await checkboxes[index].getLabel().getNative()).click();
    },
    async isCheckboxesExist() {
      return checkboxDriver.exists();
    },
    async isCheckboxesDisabled() {
      const checkboxes = base.$$(checkboxDatahook);
      const filtered = checkboxes.filter(async (checkbox) => {
        const cd = checkboxDriverFactory(checkbox, body);

        return cd.hasDisabled();
      });

      return (await checkboxes.count()) === (await filtered.count());
    },
    async isCheckboxesErrored() {
      const checkboxes = base.$$(checkboxDatahook);
      const filtered = checkboxes.filter(async (checkbox) => {
        const cd = checkboxDriverFactory(checkbox, body);

        return cd.hasError();
      });

      return (await checkboxes.count()) === (await filtered.count());
    },
    async getLang() {
      return base.attr('lang');
    },
  };
};
